<template>
  <main>
    <div class="container-fluid">
      <div class="page-header min-height-300" style="margin-right: -24px; margin-left: -34%;">
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">
                <i class="ni ni-settings-gear-65 text-dark opacity-10"></i>
                <!-- <img src="../assets/img/team-1.jpg" alt="profile_image" class="shadow-sm w-100 border-radius-lg"/> -->
              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">사이트 계정 관리</h5>
                <p class="mb-0 font-weight-bold text-sm">계정 등록, 삭제 등 계정을 관리합니다.</p>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <div class="py-4 container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="card editArea">
              <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                  <button class="btn btn-success btn-sm ms-auto" v-if="!isModify" @click="insertAccountInfo">추가</button>
                </div>
              </div>
              <div class="card-body">
                <p class="text-uppercase text-md fw-bold">필수 정보</p>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label for="accountAuth" class="form-control-label">권한</label>
                    <select id="accountAuth" class="form-control" v-model="accountAuth">
                      <option :value="'기타'" selected="selected">권한 선택</option>
                      <option :value="'관리자'">관리자</option>
                      <option :value="'플래너'">플래너</option>
                      <option :value="'펫'">펫DB용</option>
                      <option :value="'기타사용자'">기타사용자</option>
                    </select>
                  </div>
                  <div class="col-md-6 mb-2" v-if="accountAuth != '플래너'">
                    <label for="accountName" class="form-control-label">이름</label>
                    <input id="accountName" class="form-control invalid" type="text" v-model="accountName" placeholder="이름"/>
                  </div>
                  <div class="col-md-6 mb-2" v-if="accountAuth == '플래너'">
                    <label for="accountName2" class="form-control-label">이름</label>
                    <select id="accountName2" class="form-control" v-model="accountName2">
                      <option :value="'기타'" selected="selected">플래너 선택</option>
                      <option :value="planner.name" v-for="(planner, i) in plannerInfo" :key="i">{{ planner.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label for="accountID" class="form-control-label">아이디</label>
                    <input id="accountID" class="form-control invalid" type="text" v-model="accountID" placeholder="아이디"/>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label for="accountPW" class="form-control-label">비밀번호</label>
                    <input id="accountPW" class="form-control invalid" type="password" v-model="accountPW" placeholder="비밀번호"/>
                  </div>
                  <div class="row col-md-12 rounded-3 bg-light bg-opacity-50 p-4 w-100 m-auto mt-5 text-secondary">
                    <div class="col-md-12">
                      <div>[관리자]</div>
                      <ol class="">
                        <li class="">사이트 최고 관리자</li>
                        <li>모든 권한이 있음</li>
                      </ol>
                    </div>
                    <div class="col-md-12">
                      <div>[플래너]</div>
                      <ol>
                        <li>업무에 관한 권한만 있음(고객 정보/관리, 개선요청)</li>
                      </ol>
                    </div>
                    <div class="col-md-12">
                      <div>[펫DB용]</div>
                      <ol>
                        <li>펫DB에 관한 권한만 있음</li>
                      </ol>
                    </div>
                    <div class="col-md-12">
                      <div>[기타사용자]</div>
                      <ol>
                        <li>고객 정보에 관한 권한만 있음</li>
                        <li>주민등록번호 마스킹 처리</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="col-md-4">
            <div class="card">
              <div class="card-header pb-0 px-3">
                <span class="mb-0 float-start" style="font-size: 1rem; line-height: 1.625; font-weight: 600; margin-top: 0; color: #344767">계정 목록</span>
                <input type="text" class="form-control float-end" placeholder="검색어 입력" @input="search($event.target.value)" style="display: inline; width: 50%;"/>
              </div>
              <div class="card-body pt-4 p-3">
                <ul class="list-group ulAccountList onmaum-overflow-y onmaum-overflow-type02">
                  <li class="list-group-item border-0 p-4 mb-2 mb-3 bg-gray-100 border-radius-lg" :class="'class-' + account._id" v-for="(account, i) in accountInfo" :key="i">
                    <div class="flex-column">
                      <div class="ms-auto row">
                        <div class="col-md-6">
                          <span class="mb-3 text-md text-dark" style="font-weight: 600;">{{account.user_name}}</span>
                        </div>
                        <div class="col-md-3">
                        </div>
                        <div class="col-md-3">
                          <button class="btn btn-link text-danger text-gradient px-3 mb-0" @click="deleteAccountInfo(account)" v-if="(account.user_id != 'isaack0427' && account.user_id != 'chjy8755')">
                            <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                      <div class="mb-2 text-xs">
                        아이디
                        <span class="text-dark ms-sm-2 font-weight-bold">{{ `${account.user_id}` }}</span>
                      </div>
                      <div class="mb-2 text-xs">
                        권한
                        <span class="text-dark ms-sm-2 font-weight-bold">{{ `${account.user_type}` }}</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  </main>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'SiteManage',
  data(){
    return {
      accountID: '',
      accountPW: '',
      accountName: '',
      accountName2: '기타',
      accountAuth: '기타',
    }
  },

  computed: {
      accountInfo(){
        return this.$store.state.login.accountInfo;
      },
      plannerInfo(){
        return this.$store.state.planner.plannerInfo;
      },
  },

  methods:{
    //state 값 reset
    resetStates(){
      this.accountID = '';
      this.accountPW = '';
      this.accountName = '';
      this.accountName2 = '기타';
      this.accountAuth = '기타';
    },

    //입력 저장
    insertAccountInfo(){
      if(this.accountAuth == '기타'){
        this.$store.commit('setAlert', {
                                          'alertStatus': 'notice'
                                          ,'alertTitle': '계정 관리'
                                          ,'alertContent': `권한을 선택해주세요`
                                      });
        return;
      }

      if(this.accountAuth != '플래너' && this.accountName == ''){
        this.$store.commit('setAlert', {
                                          'alertStatus': 'notice'
                                          ,'alertTitle': '계정 관리'
                                          ,'alertContent': `이름을 입력해주세요`
                                      });
        return;
      }

      if(this.accountAuth == '플래너' && this.accountName2 == '기타'){
        this.$store.commit('setAlert', {
                                          'alertStatus': 'notice'
                                          ,'alertTitle': '계정 관리'
                                          ,'alertContent': `이름을 선택해주세요. 플래너 이름이 없으면 '플래너관리'에서 플래너 정보 등록을 먼저 진행해주세요.`
                                      });
        return;
      }

      if(this.accountID.length < 4){
        this.$store.commit('setAlert', {
                                          'alertStatus': 'notice'
                                          ,'alertTitle': '계정 관리'
                                          ,'alertContent': `아이디는 4자리 이상 입력해주세요`
                                      });
        return;
      }

      if(this.accountPW.length < 4){
        this.$store.commit('setAlert', {
                                          'alertStatus': 'notice'
                                          ,'alertTitle': '계정 관리'
                                          ,'alertContent': `비밀번호는 4자리 이상 입력해주세요`
                                      });
        return;
      }

      this.$store.dispatch('insertAccountInfo', { user_id: this.accountID
                                                  ,user_pw: this.accountPW
                                                  ,user_name: this.accountAuth != '플래너' ? this.accountName : this.accountName2
                                                  ,user_type: this.accountAuth
                                                  ,insert_date: new Date().toLocaleString()
                                                });
      this.resetStates();
    },

    //삭제
    deleteAccountInfo(info){
      // if(confirm(`선택한 계정 정보를 삭제하시겠습니까? \n\n>>1. 아이디: ${info.user_id} \n\n2. 이름: ${info.user_name} \n\n**삭제한 정보는 복구할 수 없으므로 신중히 삭제하시기 바랍니다.`)){
      //   this.$store.dispatch('deleteAccountInfo', info._id);
      // }
      this.$store.commit('setAlert', {
                                          'alertStatus': 'confirm'
                                          ,'alertTitle': '사이트 계정 관리'
                                          ,'alertContent': `선택한 계정 정보를 삭제하시겠습니까?|1.아이디: ${info.user_id}|2.이름: ${info.user_name}| |**삭제한 정보는 복구할 수 없으므로 신중히 삭제하시기 바랍니다.}`
                                          ,'callback': 'deleteAccountInfo'
                                          ,'parameter': {id: info._id}
                                      }
                          );
      this.resetStates();
    },

    //검색
    search(text){
      let temp = [];

      this.$store.state.login.accountInfoOrigin.forEach(a => {
        if(a.user_name.indexOf(text) > -1 || a.user_id.indexOf(text) > -1 || a.user_type.indexOf(text) > -1){
          temp.push(a);
        }
      })

      this.$store.state.login.accountInfo = temp;
    },
  },
  
  mounted(){
    //관리자만 이 페이지에 접근 가능
    if(!this.$store.state.login.userType == '관리자'){
      this.$router.push('/');
    }
    
    //플래너 정보 가져오기
    this.$store.dispatch('getAccountInfo');

    let temp = $('.editArea > .card-body');
    let h = (temp.innerHeight() - temp.height()) / 2 + temp.height();
    $('.ulAccountList').css('height', h);
  },
}
</script>

<style>

</style>